/* eslint-disable react/jsx-pascal-case */
import { Col, Form, Input, Row, Switch } from "antd";
import dayjs from 'dayjs';
import React, { useEffect, useState } from "react";

const UserForm = (
    {
        propsForm = null,
        axiosMode = "post",
        formReloadCount = 0,
        onFormFinish = () => { },
    }
) => {
    const [form] = Form.useForm();
    const [chagePassword, setChagePassword] = useState(false)

    const setFormValuesOtherThings = (formValues) => {
        //做一些你可能會用到其他component的資料整理
        let newFormValues = {
            ...formValues,
            total: (formValues?.comments * formValues?.number) || 0
        }
        if (propsForm) {
            propsForm.setFieldsValue(newFormValues)
        }
        else {
            form.setFieldsValue(newFormValues)
        }

    }

    const setDataInitialization = () => {
        //拿個下拉選單等等的資訊
    }
    const onFinish = (values) => {
        onFormFinish({
            ...values,
        })
    }
    const onValuesChange = () => {
        let formValues = null
        if (propsForm) {
            formValues = propsForm.getFieldsValue()
        }
        else {
            formValues = form.getFieldsValue()
        }
        setFormValuesOtherThings(formValues)
    }

    useEffect(() => {
        setDataInitialization()
    }, [])
    useEffect(() => {
        let formValues = null
        if (propsForm) {
            formValues = propsForm.getFieldsValue()
        }
        else {
            formValues = form.getFieldsValue()
        }
    }, [formReloadCount])

    return (
        <Row>

            <Col span={24}>
                <Form
                    labelCol={{ span: 6 }}
                    wrapperCol={{ span: 18 }}
                    layout="horizontal"
                    form={propsForm ? propsForm : form}
                    onValuesChange={onValuesChange}
                    onFinish={onFinish}
                    autoComplete="off"
                >
                    <Row gutter={[8, 8]}>
                        <Col span={24}>
                            <Form.Item
                                hidden={true}
                                name={"uid"}
                            >
                                <Input>
                                </Input>
                            </Form.Item>
                        </Col>
                        <Col span={24}>
                            <Form.Item
                                hidden={true}
                                name={"user_id"}
                            >
                                <Input>
                                </Input>
                            </Form.Item>
                        </Col>

                        <Col span={24}>
                            <Form.Item
                                label={"姓名"}
                                name={"name"}
                                rules={[
                                    {
                                        required: true,
                                        message: "請輸入"
                                    }
                                ]}
                            >
                                <Input>
                                </Input>
                            </Form.Item>
                        </Col>
                        <Col span={24}>
                            <Form.Item
                                label={"電話"}
                                name={"phone"}
                                rules={[
                                    {
                                        required: true,
                                        message: "請輸入"
                                    }
                                ]}
                            >
                                <Input>
                                </Input>
                            </Form.Item>
                        </Col>
                        <Col span={24}>
                            <Form.Item
                                label={"Email"}
                                name={"email"}
                                rules={[
                                    {
                                        required: true,
                                        message: "請輸入"
                                    }
                                ]}
                            >
                                <Input>
                                </Input>
                            </Form.Item>
                        </Col>
                        <Col span={24}>
                            <Form.Item
                                label={"地址"}
                                name={"address"}
                                
                            >
                                <Input>
                                </Input>
                            </Form.Item>
                        </Col>
                        <Col span={24}>
                            {axiosMode == "patch" && <Form.Item
                                label={"修改密碼"}
                                name="status"
                            >
                                <Switch onChange={(res) => setChagePassword(res)} />
                            </Form.Item>}
                        </Col>
                        {chagePassword && axiosMode == "patch" && <>
                           
                            <Col span={24}>

                                <Form.Item
                                    label={"修改密碼"}
                                    name="password"
                                    rules={[
                                        {
                                            required: true,
                                            message: `此為必填項目`
                                        }
                                    ]}
                                >
                                    <Input.Password autocomplete="new-password" />
                                </Form.Item>
                            </Col>
                            <Col span={24}>

                                <Form.Item
                                    label={"再次輸入"}
                                    name="password1"
                                    dependencies={['password']}
                                    hasFeedback
                                    rules={[
                                        {
                                            required: true,
                                            message: '請確認新密碼',
                                        },
                                        ({ getFieldValue }) => ({
                                            validator(_, value) {
                                                if (!value || getFieldValue('password') === value) {
                                                    return Promise.resolve();
                                                }
                                                return Promise.reject(new Error('兩次密碼不相同'));
                                            },
                                        }),
                                    ]}

                                >
                                    <Input.Password autocomplete="new-password" />
                                </Form.Item>
                            </Col>
                        </>}
                    </Row>
                </Form>
            </Col>
        </Row>


    )
}


export default UserForm;
